export type EditorDisplayState = 'EDITOR' | 'SYNCING' | 'PROCESSING_WITH_PROGRESS' | 'PROCESSING' | 'NO_SPEECH' | 'PLACEHOLDER'

export type EditorDisplayStateInputs = {
  isPostProcessingComplete: boolean
  isMinutesGenerationOngoing: boolean
  /** A run rewriting only some agenda items. The rest of the document stays readable and editable throughout. */
  isMinutesGenerationTargeted: boolean
  minutesGenerationProgress: number | null
  /**
   * Whether the meeting has a document revision. Post-processing can complete without one being written - a meeting with
   * no speech, or an outline with no items - and the editor would then open on a blank document that the schema fills
   * with an empty title.
   */
  hasEditorDocument: boolean
  isSpeechMissing: boolean
  editorConstructed: boolean
  hasInitiallySynced: boolean
}

export function deriveEditorDisplayState(inputs: EditorDisplayStateInputs): EditorDisplayState {
  // A targeted run leaves post-processing incomplete while it runs, but covering the document with a loader
  // would defeat the point of it: the agenda items it is rewriting are locked individually instead.
  if ((inputs.isPostProcessingComplete || inputs.isMinutesGenerationTargeted) && inputs.hasEditorDocument) {
    return inputs.editorConstructed && inputs.hasInitiallySynced ? 'EDITOR' : 'SYNCING'
  }
  if (inputs.isMinutesGenerationOngoing) {
    return inputs.minutesGenerationProgress !== null ? 'PROCESSING_WITH_PROGRESS' : 'PROCESSING'
  }
  if (inputs.isSpeechMissing) {
    return 'NO_SPEECH'
  }
  return 'PLACEHOLDER'
}
